import { defineTextStyles } from '@chakra-ui/react';

export const textStyles = defineTextStyles({
  xs: {
    value: {
      fontSize: 'xs', // 12px
      lineHeight: 1.25,
    },
  },
  sm: {
    value: {
      fontSize: 'sm', // 14px
      lineHeight: 1.25,
    },
  },
  md: {
    value: {
      fontSize: 'md', // 16px
      lineHeight: 1.25,
    },
  },
  lg: {
    value: {
      fontSize: 'lg', // 18px
      lineHeight: 1.25,
    },
  },
  xl: {
    value: {
      fontSize: 'xl', // 20px
      lineHeight: 1.25,
    },
  },
  screenSm: {
    value: {
      fontSize: 'screenSm', // 12-14
      lineHeight: 1.25,
    },
  },
  screenStd: {
    value: {
      fontSize: 'screenStd', // 14-16
      lineHeight: 1.25,
    },
  },
  screenMed: {
    value: {
      fontSize: 'screenMed', // 16-18
      lineHeight: 1.25,
    },
  },
  screenLg: {
    value: {
      fontSize: 'screenLg', // 18-20
      lineHeight: 1.25,
    },
  },
});
